export enum PermissionActions {
    changePermissions,
    resentInvite,
    removeUser,
}
